document.addEventListener("DOMContentLoaded", () => {
  const productNavItem = document.querySelector(
    '.yc-global-header-nav__item.type-02 > a[href*="/product/"]'
  );
  const dropdown = document.querySelector('.yc-dropdown__group');

  if (!productNavItem || !dropdown) return;

  let isOpen = false;
  let closeTimer = null;

  // メニューを開く
  const openMenu = () => {
    clearTimeout(closeTimer);
    dropdown.classList.add("active");
    isOpen = true;
  };

  // 閉じる（若干ディレイ入れて accidental close 防止）
  const closeMenu = () => {
    closeTimer = setTimeout(() => {
      dropdown.classList.remove("active");
      isOpen = false;
    }, 120);
  };

  // 製品に hover → メニュー開く
  productNavItem.addEventListener("mouseenter", openMenu);

  // 製品から離れたら閉じる
  productNavItem.addEventListener("mouseleave", () => {
    if (!dropdown.matches(":hover")) closeMenu();
  });

  // メニュー内に入ったら閉じない
  dropdown.addEventListener("mouseenter", () => {
    clearTimeout(closeTimer);
  });

  // メニューから出たら閉じる
  dropdown.addEventListener("mouseleave", () => {
    if (!productNavItem.matches(":hover")) closeMenu();
  });
});
